/** @jsxImportSource @emotion/react */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { getPowerBIEmbedInfo } from "../../../actions/Auth/actions";
import { RootState } from "../../../reducers";

function PowerBI() {
    const dispatch = useDispatch();
    const powerbiEmbedInfo = useSelector<RootState, any>((state) => state.auth.powerbiEmbedInfo);
    const { "*": subRoute } = useParams(); // Get the sub-route dynamically
    useEffect(() => {
        const [workspaceId, reportId] = subRoute?.split("/") || [];
        if (
            !powerbiEmbedInfo
            || !powerbiEmbedInfo.reportConfig[0].embedUrl.includes(reportId)
        ) {
            dispatch(getPowerBIEmbedInfo(workspaceId, reportId));
        }
    }, [powerbiEmbedInfo, subRoute]);

    return powerbiEmbedInfo
        ? <>
            <PowerBIEmbed
                embedConfig = {{
                    type: "report",
                    id: powerbiEmbedInfo.reportConfig[0].reportId,
                    embedUrl: powerbiEmbedInfo.reportConfig[0].embedUrl,
                    accessToken: powerbiEmbedInfo.accessToken,
                    tokenType: models.TokenType.Embed,
                    settings: {
                        layoutType: models.LayoutType.Custom,
                        customLayout: {
                            displayOption: models.DisplayOption.FitToPage,
                        },
                        panes: {
                            filters: {
                                expanded: false,
                                visible: false,
                            },
                        },
                        background: models.BackgroundType.Transparent,
                    },
                }}
                getEmbeddedComponent = {(embed) => {
                    (embed.iframe as any).style = "height:55em; width:100%";
                }}
            /></>
        : <></>;
}

export default PowerBI;
